import { useSignOut } from "Auth/Hooks/useSignOut";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { Home, XCircle } from "Shared/appIcons";
import { UnauthenticatedLayout } from "Shared/Layouts/UnauthenticatedLayout";
import { UnstyledLink } from "Shared/Routing/UnstyledLink";
import { Button } from "@/components/ui/button";

export const Error403Page = () => {
	const { t } = useResource();
	const signOut = useSignOut();

	return (
		<UnauthenticatedLayout title={t(Resources.Errors.Error403.Title)}>
			<div className="space-y-4 text-center">
				<h1 className="text-3xl font-bold">
					{t(Resources.Errors.Error403.Title)}
				</h1>
				<p className="text-lg font-medium">
					{t(Resources.Errors.Error403.Subtitle)}
				</p>
				<XCircle className="text-muted-foreground mx-auto h-24 w-24" />
				<div className="flex items-center justify-center gap-3">
					<UnstyledLink to="/">
						<Button size="lg">
							<Home className="mr-2 h-4 w-4" />
							{t(Resources.Errors.Error404.Home)}
						</Button>
					</UnstyledLink>
					<Button variant="outline" size="lg" onClick={() => signOut()}>
						{t(Resources.Common.SignOut)}
					</Button>
				</div>
			</div>
		</UnauthenticatedLayout>
	);
};
